import Vue, { CreateElement, RenderContext, VNode } from "vue";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
  hasAppend: boolean;
  hasPrepend: boolean;
  disabled: boolean;
}
export default Vue.extend({
  functional: true,
  name: "BaseInputField",
  props: {
    hasAppend: { type: Boolean, default: false },
    hasPrepend: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { hasPrepend, hasAppend, disabled } = ctx.props;

    return (
      <div staticClass={ctx.data.staticClass} class={["input__box", ctx.data.class, { __disabled: disabled }]}>
        {ctx.scopedSlots.label && ctx.scopedSlots.label({ classes: { input__label: true } })}
        <div staticClass="input-field__wrapper" class={{ "__append-icon": hasAppend, "__prepend-icon": hasPrepend }}>
          {ctx.scopedSlots.default && ctx.scopedSlots.default({ classes: { input__field: true } })}
          {ctx.scopedSlots.prependIcon && ctx.scopedSlots.prependIcon({ classes: { "input__icon __prepend": true } })}
          {ctx.scopedSlots.appendIcon && ctx.scopedSlots.appendIcon({ classes: { "input__icon __append": true } })}
        </div>
        {ctx.scopedSlots.hint && ctx.scopedSlots.hint({})}
      </div>
    );
  },
});
